import oracle from '../img/trusted/oracle.png'
import morphus from '../img/trusted/morphus.png'
import samsung from '../img/trusted/samsung.png'
import monday from '../img/trusted/monday.png'
import segment from '../img/trusted/segment.png'
export default function TrustedPartners() {
    return <>
        <div className='trustedPartner py-5' >
            <div className="container" >
                <h3>Trusted By Over 100+ Startups & Freelance business
                    who is using Exquisite Moves Services! </h3>
                <ul>
                    <li><img src={oracle} className="img-fluid" alt='trusted partners' /></li>
                    <li><img src={morphus} className="img-fluid" alt='trusted partners' /></li>
                    <li><img src={samsung} className="img-fluid" alt='trusted partners' /></li>
                    <li><img src={monday} className="img-fluid" alt='trusted partners' /></li>
                    <li><img src={segment} className="img-fluid" alt='trusted partners' /></li>
                </ul>
            </div>
        </div>
    </>
}